export default __webpack_public_path__ + "static/media/1802.b527a810.png";